import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaDataListComponent } from 'src/app/shared/ui-kit/pa-data-list/pa-data-list.component';
import { PaInfoBlockComponent } from 'src/app/shared/ui-kit/pa-info-block/pa-info-block.component';
import {
  DataListItem,
  DataListType,
  DataListValueState,
} from 'src/app/shared/ui-kit/pa-data-list/models/pa-data-list.model';
import { FileFromServer } from 'src/app/core/models/files';

@Component({
  selector: 'app-data-list-view',
  standalone: true,
  imports: [CommonModule, PaDataListComponent, PaInfoBlockComponent],
  templateUrl: './data-list-view.component.html',
  styleUrls: ['./data-list-view.component.scss'],
})
export class DataListViewComponent {
  textData: DataListItem[] = [
    { label: 'Название', type: DataListType.TEXT, value: 'Обучение стажера' },
    { label: 'Срок', type: DataListType.TEXT, value: '02.09.2025' },
    { label: 'Повтор', type: DataListType.TEXT, value: 'Не повторять' },
  ];

  mixedData: DataListItem[] = [
    {
      label: 'text',
      type: DataListType.TEXT,
      value: 'Обучение стажера',
    },
    {
      label: 'Ссылка',
      type: DataListType.LINK,
      value: 'Открыть инструкцию',
      url: 'https://my.pvz-admin.ru',
    },
    {
      label: 'Вложения',
      type: DataListType.FILES,
      value: [
        {
          uuid: '40898023-be07-4bfe-a310-98815f1950a3',
          url: 'https://cdn.pvz-admin.ru/images/25/09/22/089bdbdb-852a-4646-9697-af236ebe1492',
          url_preview:
            'https://cdn.pvz-admin.ru/images/25/09/22/089bdbdb-852a-4646-9697-af236ebe1492_x480',
          type: 'image',
          original_name: 'Frame 29 (1)',
          ext: 'webp',
          filesize: 46728,
          added: '2025-09-22T11:24:11.000Z',
        } as FileFromServer,
      ],
    },
    {
      label: 'text (icon)',
      type: DataListType.TEXT,
      value: '02.09.2025',
      icon: 'repeat',
    },
    {
      label: 'tags',
      type: DataListType.TAGS,
      value: [
        { label: 'В работе', severity: 'danger' },
        { label: 'Средний', severity: 'warn' },
      ],
    },
    {
      label: 'link',
      type: DataListType.LINK,
      value: 'Перейти на сайт',
      url: 'https://pvz-admin.ru',
    },
    {
      label: 'function',
      type: DataListType.FUNCTION,
      value: 'Нажми меня',
      function: () => alert('function вызван'),
    },
    {
      label: 'textAndCount',
      type: DataListType.TEXT_AND_COUNT,
      value: ['Москва Сокол', 'Москва Орёл', 'СПб Невский'],
      countShowElements: 1,
    },
    {
      label: 'textExpandableList',
      type: DataListType.TEXT_EXPANDABLE_LIST,
      value: ['Иванов И.И.', 'Петров П.П.', 'Сидоров С.С.'],
      countShowElements: 1,
    },
    {
      label: 'telegram',
      type: DataListType.TELEGRAM,
      value: '@pvz_admin',
    },
    {
      label: 'email',
      type: DataListType.EMAIL,
      value: 'info@pvz-admin.ru',
    },
    {
      label: 'phone',
      type: DataListType.PHONE,
      value: '+7 999 123-45-67',
    },
    {
      label: 'files',
      type: DataListType.FILES,
      value: [
        {
          uuid: '40898023-be07-4bfe-a310-98815f1950a3',
          url: 'https://cdn.pvz-admin.ru/images/25/09/22/089bdbdb-852a-4646-9697-af236ebe1492',
          url_preview:
            'https://cdn.pvz-admin.ru/images/25/09/22/089bdbdb-852a-4646-9697-af236ebe1492_x480',
          type: 'image',
          original_name: 'Frame 29 (1)',
          ext: 'webp',
          filesize: 46728,
          added: '2025-09-22T11:24:11.000Z',
        } as FileFromServer,
        {
          uuid: '40898023-be07-4bfe-a310-98815f1950a3',
          url: 'https://cdn.pvz-admin.ru/images/25/09/22/089bdbdb-852a-4646-9697-af236ebe1492',
          url_preview:
            'https://cdn.pvz-admin.ru/images/25/09/22/089bdbdb-852a-4646-9697-af236ebe1492_x480',
          type: 'image',
          original_name: 'Frame 29 (2)',
          ext: 'webp',
          filesize: 46728,
          added: '2025-09-22T11:24:11.000Z',
        } as FileFromServer,
      ],
    },
  ];

  validationData: DataListItem[] = [
    {
      label: 'Название ПВЗ',
      type: DataListType.TEXT,
      value: '',
      valueState: DataListValueState.MISSING_REQUIRED,
    },
    {
      label: 'Адрес ПВЗ',
      type: DataListType.TEXT,
      value: 'г. Москва, ул. Ленина, 10',
    },
    {
      label: 'Маркетплейс',
      type: DataListType.TEXT,
      value: 'Wildberis',
      valueState: DataListValueState.ERROR,
    },
    {
      label: 'Тип',
      type: DataListType.TEXT,
      value: 'Фирменный',
    },
    {
      label: 'Часовой пояс',
      type: DataListType.TEXT,
      value: '',
      valueState: DataListValueState.MISSING_REQUIRED,
    },
  ];

  lineThroughData: DataListItem[] = [
    {
      label: 'Срок',
      type: DataListType.TEXT_LINE_THROUGH,
      value: '01.09.2025',
    },
    { label: 'Срок (актуальный)', type: DataListType.TEXT, value: '15.09.2025' },
    {
      label: 'Комментарий',
      type: DataListType.TEXT_LINE_THROUGH,
      value: 'Старая формулировка заменена новой.',
    },
  ];
}